import { useContext } from 'react';
import { VaultContext, VaultContextValue } from './VaultContext';

export function useZkVault(): VaultContextValue {
  const ctx = useContext(VaultContext);
  if (!ctx) throw new Error('useZkVault must be used within a <VaultProvider>');
  return ctx;
}
